import * as S from './styles.ts';
import { H2, P } from '@template/components';
import { useTypedSelector } from '@/redux/helpers/hooks.ts';
import Result from '@template/blocks/domain/DomainNameCustomSearchResults/Result';

const Header = ({
  title,
  subTitle,
  hidePrimary,
}: {
  title?: string;
  subTitle?: string;
  hidePrimary?: boolean;
}) => {
  const primaryDomain = useTypedSelector(
    (state) => state.domains.search.results.primary
  );

  if (!title && !subTitle && !primaryDomain) return;

  return (
    <S.Wrapper>
      {title && <H2>{title}</H2>}
      <Result domain={primaryDomain} primary />
      {((hidePrimary && subTitle) || (primaryDomain && subTitle)) && (
        <P>{subTitle}</P>
      )}
    </S.Wrapper>
  );
};

export default Header;
